import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { LenticLogo } from '../LenticLogo';
import { navLinks } from '../../data/site';

/** Hash links only resolve on the home page, so prefix them when elsewhere. */
export function useHashHref() {
  const {
    pathname
  } = useLocation();
  const isHome = pathname === '/';
  return (href: string) => href.startsWith('#') && !isHome ? `/${href}` : href;
}
export function Nav() {
  const [open, setOpen] = useState(false);
  const hrefFor = useHashHref();
  return <header className="sticky top-0 z-50 w-full border-b border-mist/80 bg-bone/90 backdrop-blur" data-id="element-258" data-mp="x1up64hlabbj">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-4 lg:px-10" data-id="element-259" data-mp="112wo0k7lglcz">
        <Link to="/" aria-label="Lentic home" className="flex items-center" data-id="element-260" data-mp="2yt7tosfnah72">
          <LenticLogo size={40} className="lg:hidden" data-id="element-261" data-mp="2yvanzontywhl" />
          <LenticLogo size={34} className="hidden lg:block" data-id="element-262" data-mp="32vb6bke1vrtx" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary" data-id="element-263" data-mp="3i8jysfpu927z">
          {navLinks.map(link => link.href.startsWith('/') ? <Link key={link.href} to={link.href} className="text-base text-graphite transition-colors hover:text-ink" data-id="element-264" data-mp="3dg0obrmg6n7e">
                {link.label}
              </Link> : <a key={link.href} href={hrefFor(link.href)} className="text-base text-graphite transition-colors hover:text-ink" data-id="element-265" data-mp="33jxj2cwau8g8">
                {link.label}
              </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-266" data-mp="2ym527repkc">
          <a href={hrefFor('#contact')} className="hidden rounded-full bg-ink px-5 py-2.5 text-[15px] font-semibold text-bone transition-colors hover:bg-teal sm:inline-flex" data-id="element-267" data-mp="38c4pst0wq1">
            Book a walkthrough
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-mist text-ink lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-268" data-mp="3mbzwzghk3ams">
            {open ? <XIcon className="h-5 w-5" data-id="element-269" data-mp="12wcjvxljg1gd" /> : <MenuIcon className="h-5 w-5" data-id="element-270" data-mp="12w2nns9wgy28" />}
          </button>
        </div>
      </div>

      {open ? <nav className="border-t border-mist bg-bone px-6 py-4 lg:hidden" aria-label="Mobile" data-id="element-271" data-mp="16w3ekce6r1q6">
          <ul className="space-y-3" data-id="element-272" data-mp="swvdfdygpjjc">
            {navLinks.map(link => <li key={link.href} data-id="element-273" data-mp="xvf23m4fx9fe">
                {link.href.startsWith('/') ? <Link to={link.href} onClick={() => setOpen(false)} className="block text-base text-ink" data-id="element-274" data-mp="xy14z8gdz0ra">
                    {link.label}
                  </Link> : <a href={hrefFor(link.href)} onClick={() => setOpen(false)} className="block text-base text-ink" data-id="element-275" data-mp="nz25oghighgy">
                    {link.label}
                  </a>}
              </li>)}
            <li data-id="element-276" data-mp="f4x87e7vg7sg">
              <a href={hrefFor('#record')} onClick={() => setOpen(false)} className="block text-base text-ink" data-id="element-277" data-mp="f6i7fh54sewn">
                See what's in a decision record
              </a>
            </li>
            <li data-id="element-278" data-mp="567s9qzjcxeu">
              <a href={hrefFor('#contact')} onClick={() => setOpen(false)} className="block text-base font-semibold text-teal" data-id="element-279" data-mp="56raz9x0fptx">
                Book a walkthrough
              </a>
            </li>
          </ul>
        </nav> : null}
    </header>;
}